import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoomIdService } from './room-id.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../user/auth.service';
import { UIMesageService } from '../common/ui-message.service';
import { EstimateService } from './estimate.service';
import { NGXLogger as LoggerService } from "ngx-logger";
import { GoogleAnalyticsService } from '../common/google-analytics.service';
import { UserService } from '../user/user.service';
import { ResponsiveService } from '../common/responsive.service';
import { filter, Observable, Subscription } from 'rxjs';
@Component({
    selector: 'room-gate',
    templateUrl: './room-gate.component.html',
    styleUrls: ['./room-gate.component.scss']
})

export class RoomGateComponent implements OnInit, OnDestroy {
    enterRoomForm: FormGroup;
    public roomId: FormControl;
    public newDeveloperName: FormControl;
    isLoading: boolean
    roomExists: boolean
    isLoggedIn: boolean
    isPremium: boolean
    isTestMode: boolean
    navEnd: Observable<NavigationEnd>;
    navSub: Subscription;
    constructor(
        public roomIdService: RoomIdService,
        private estimateService: EstimateService,
        public authService: AuthService,
        private uiMessage: UIMesageService,
        private logger: LoggerService,
        private googleAnalyticsService: GoogleAnalyticsService,
        private userService: UserService,
        public responsiveService: ResponsiveService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
        // oberve the navigation to react room  changes (top bar)
        (router.events.pipe(
            filter(evt => evt instanceof NavigationEnd)
        ) as Observable<NavigationEnd>)
            .subscribe(evt => { this.handleNavigationEvent(evt) });
        this.initForm()
    }

    async ngOnInit() {
        await this.init()
    }

    async init() {
        this.isLoading = true
        this.isPremium = false
        this.isTestMode = this.route.snapshot.data['isTestMode'] === true
        this.roomIdService.setRoomId(this.route);
        await this.setRoomExists()
        this.isLoggedIn = this.userService.isLoggedIn()
        if (this.isLoggedIn) {
            this.proceedAfterLogggedIn()
        } else {
            this.isLoading = false
            // form is displayed - continue with handleSubmit
        }
    }

    private async proceedAfterLogggedIn() {
        this.isPremium = await this.estimateService.getOwnerHasPremium(this.roomIdService.getCurrentRoomID())
        await this.estimateService.registerUserInRoom(
            this.roomIdService.getCurrentRoomID(),
            this.userService.getDisplayName(),
            this.userService.getUid()
        );
        this.isLoading = false;
    }

    public async handleSubmit(formValues) {
        this.isLoading = true;
        this.logger.log('logingate: enterRoomForm');
        if (this.enterRoomForm.valid) {
            try {
                await this.authService.signUpAnonymous(this.newDeveloperName.value, false);
                this.isLoggedIn = true;
                this.proceedAfterLogggedIn()
            } catch (error) {
                this.uiMessage.error(error, 'Entering room failed. ');
            }
        } else {
            this.uiMessage.warning('Form not valid');
        }
    }

    private handleNavigationEvent(evt: NavigationEnd) {
        this.logger.log('RoomGate: Navigation event');
        this.roomIdService.setRoomId(this.route);
        this.init()
    }

    ngOnDestroy(): void {
        this.navSub?.unsubscribe();
    }

    private async setRoomExists() {
        this.logger.log('ngOnInit:this.roomIdService.getCurrentRoomID()', this.roomIdService.getCurrentRoomID())
        this.roomExists = await this.estimateService.isExistentRoom(this.roomIdService.getCurrentRoomID());
    }

    private initForm() {
        this.newDeveloperName = new FormControl(
            '',
            [Validators.required]
        );
        this.enterRoomForm = new FormGroup({
            newDeveloperName: this.newDeveloperName,
        });
    }

    getDeveloperNameErrorMessage() {
        return this.newDeveloperName.hasError('required') ? 'Please enter your name' :
            '';
    }

    cancel() {
        window.location.href = '/';
    }

}
